export default "__VITE_ASSET__Dd3mT2Fv__ 300w";